export default {"src":"/_next/static/media/glow-gradle.393bdc70.svg","height":510,"width":694,"blurWidth":0,"blurHeight":0};